// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"2c04d989","364":"8db0f1c0","453":"354bf2f6","462":"2cf222a0","547":"fccfe523","950":"88ac080b"}[chunkId] + ".chunk.js";
};